import MatchEvents from '@/components/server/MatchEvents';
import MatchStats from '@/components/server/MatchStats';
import { Match, MatchNavigation } from './ThongTinTranDau';
import { useEffect, useState } from 'react';
import MatchServices from '@/services/MatchServices';
import MatchLineups from '@/components/server/MatchLineups';
import RecentMatchData from '@/components/server/RecentMatchData';
import MatchStatistics from '@/components/server/MatchStatistics';
import MatchGoalLossRatio from '@/components/server/MatchGoalLossRatio';
import MatchInfo from '@/components/server/MatchInfo';
import MatchAnalysisOdds from '@/components/server/MatchAnalysisOdds';
import CompareStrength from '@/components/server/CompareStrength';
import MatchRanking from '@/components/server/MatchStanding';
import RecentLeaderBoard from '@/components/server/RecentLeaderBoard';
import MatchLatest from '@/components/server/MatchLatest';
import RecentLineup from '@/components/server/RecentLineup';
import MatchAnalysis from '@/components/server/MatchAnalysis';
import CompareOddTable from '../CompareOddTable';
// import MatchAnalysis from "@/components/server/MatchAnalysis";
// import MatchAnalysisOdds from "@/components/server/MatchAnalysisOdds";
// import RecentLeaderBoard from "@/components/server/RecentLeaderBoard";
// import RecentLineup from "@/components/server/RecentLineup";
// import CompareStrength from "@/components/server/CompareStrength";
// import MatchLatest from "@/components/server/MatchLatest";
// import MatchRanking from "@/components/server/MatchStanding";


const ThongTinTranDauPlugin = ({ league }) => {
  const matchId = league;
  const [activeTab, setActiveTab] = useState('chitiet');
  const [match, setMatch] = useState(null);
  const [matchAnalysis, setMatchAnalysis] = useState(null);
  const [liveOdd, setLiveOdd] = useState(null);
  const handleOnClickNav = (tab) => {
    setActiveTab(tab);
  };

  
  useEffect(async () => {
    const [match, matchAnalysis, liveOdd] = await Promise.all([
      MatchServices.getMatchById(matchId),
      MatchServices.getMatchAnalysis(matchId),
      MatchServices.getLiveOddByMatchId(matchId),
    ])
    setMatch(match);
    setMatchAnalysis(matchAnalysis);
    setLiveOdd(liveOdd);
  }, []);

 
  return (
    <>
    <Match matchId={matchId} />
    <MatchNavigation onClickTab={handleOnClickNav}/>
    
    {activeTab === 'chitiet' && (
      <div>
        <MatchEvents match={match} />
        <MatchLineups match={match} />
        <MatchStats match={match} />
        <RecentMatchData matchAnalysis={matchAnalysis} />
        <MatchStatistics match={match} />
        <MatchGoalLossRatio match={match} status={match?.status} />
        <MatchInfo match={match} />
      </div>
    )}

    {activeTab === 'phantich' && (
      <div>
          <MatchAnalysisOdds matchId={ matchId }/>
          <CompareStrength matchId={matchId} />
          <MatchRanking matchId={ matchId }/>
          <RecentLeaderBoard matchId={ matchId }/>
          <MatchLatest matchId={ matchId } />
          <RecentLineup matchId={ matchId }/>
          <MatchAnalysis matchId={ matchId }/> 
      </div>
    )}

    {activeTab === 'sosanhtile' && (
      <div>
        <CompareOddTable matchId={matchId} match={match} data={liveOdd} />
      </div>
    )}
    </>
  );
};

export default ThongTinTranDauPlugin;